import React from 'react';
import { ModalsKeys } from 'global';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { EventCalendar, CreateEventDialog, UpdateCalendarViewDialog } from 'modules/dealActivity/calendar';

export const CalendarPage = () => {
  return (
    <PageContainer
      title="Calendar"
      modals={{
        [ModalsKeys.CreateEventDialog]: <CreateEventDialog />,
        [ModalsKeys.UpdateCalendarViewDialog]: <UpdateCalendarViewDialog />,
      }}
    >
      <EventCalendar />
    </PageContainer>
  );
};
